import React, { memo, useState } from 'react'
import { Container } from 'react-bootstrap'
import './NavbarComponent.css'
import { IoIosArrowDown } from 'react-icons/io'
import SubMenuComponent from '../SubMenuComponent/SubMenuComponent'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
function NavbarComponent() {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(null);
  const handleMouseOver = (index) => setSelectedMenuIndex(index);
  const handleMouseLeave = () => setSelectedMenuIndex(null);
  const [courseMenuList, setCourseMenuList] = useState([])
  const [productMenuList, setProductMenuList] = useState([])
  useEffect(() => {
    axiosConfig.get('/api/Categories?categoryType=0').then((res) => {
      setCourseMenuList(res.data)
    })
    axiosConfig.get('/api/Categories?categoryType=1').then((res) => {
      setProductMenuList(res.data)
    })
  }, [])

  let menuList = [
    {
      id: 0,
      menuName: 'صفحه اصلی',
      href: '/',
      subMenus: []
    },
    {
      id: 1,
      menuName: 'محصولات',
      href: '/products',
      subMenus: []
    },
    {
      id: 2,
      menuName: 'دوره ها',
      href: '/courses',
      subMenus: []
    },
    {
      id: 3,
      menuName: 'مقالات',
      href: '/articles',
      subMenus: []
    },
    {
      id: 4,
      menuName: 'مشاوره',
      href: '/counseling',
      subMenus: []
    },
    {
      id: 5,
      menuName: 'درباره ما',
      href: '/aboutus',
      subMenus: []
    }
  ]
  menuList[1].subMenus.push(productMenuList)
  menuList[2].subMenus.push(courseMenuList)

  return (
    <div className='navbar-section'>
      <Container fluid='lg' className='navbar-container'>
        <ul className='navbar-list'>
          {
            menuList.map((menu, index) => (
              <li onMouseOver={() => handleMouseOver(index)} key={index}
                onMouseLeave={handleMouseLeave} className='navbar-component-list'>
                <Link to={menu.href}>
                  {menu.menuName}
                </Link>
                {
                  menu.subMenus.length ? (
                    <>
                      <IoIosArrowDown />
                      <SubMenuComponent
                        index={index} subMenus={menu.subMenus.length ? menu.subMenus[0] : null} selectedMenuIndex={selectedMenuIndex} />
                    </>
                  ) : null
                }


              </li>
            ))
          }
        </ul>
      </Container>
    </div>
  )
}

export default memo(NavbarComponent)
